import { useEffect, useState } from "react";

export type Theme = "light" | "dark";
const KEY = "heylife.admin.theme";

function initial(): Theme {
  const saved = typeof localStorage !== "undefined" ? (localStorage.getItem(KEY) as Theme | null) : null;
  return saved === "light" ? "light" : "dark";
}

/**
 * Command Center theme (FR-ADM-09). Dark is the default, as in the customer's Admin v3 prototype;
 * light is an opt-in alternate kept per browser. Applied via `data-theme` on <html> while the
 * Command Center is mounted; without the attribute the tokens resolve to the dark theme.
 */
export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, set] = useState<Theme>(initial);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    return () => {
      delete document.documentElement.dataset.theme;
    };
  }, [theme]);
  return [
    theme,
    (t) => {
      localStorage.setItem(KEY, t);
      set(t);
    },
  ];
}
